export default __webpack_public_path__ + "static/media/i6.834540ba.webp";